import useSWR from "swr";
import { endpoints } from "@/lib/api";

const REFRESH_MS = 60_000;

export function useCurrent() {
  return useSWR("weather/current", endpoints.current, {
    refreshInterval: REFRESH_MS,
    revalidateOnFocus: true,
  });
}

export function useHistory(range = "24h") {
  return useSWR(["weather/history", range], () => endpoints.history(range), {
    refreshInterval: REFRESH_MS * 5,
  });
}

export function useRecords() {
  return useSWR("weather/records", endpoints.records);
}

export function useStation() {
  return useSWR("station", endpoints.station);
}
